export class Save {
  save = [];
  completed = false;
  NATIONALITIES = []
  constructor() {
    this.save = this._initSave();
  }

  private _initSave() {
    return [
      {
        key: 'firstName',
        label: 'First Name',
        order: 1,
        required: true,
        controlType: 'textbox',
        type: 'text',
        value: ''
      },
      {
        key: 'lastName',
        label: 'Last Name',
        order: 2,
        required: true,
        controlType: 'textbox',
        type: 'text',
        value: ''
      },
      {
        key: 'phone',
        label: 'Phone',
        order: 3,
        required: true,
        controlType: 'textbox',
        type: 'text',
        value: ''
      },
      {
        key: 'nric',
        label: 'National Registration Identity Card',
        order: 4,
        required: false,
        controlType: 'textbox',
        type: 'text',
        value: ''
      },
      {
        key: 'nationality',
        label: 'Nationality',
        order: 5,
        required: true,
        controlType: 'textbox',
        type: 'text',
        value: ''
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/save.ts